// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__2fOiq","overflowing":"ReadFullNote_overflowing__1nSIo"};